module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_4-d6b22a3880f7497bfea541e4172e3e37.jpg";